import { action } from 'satcheljs';
import type { CalendarProviderType } from '../store/schema/CalendarProviderType';
import type { SubscribeCalendarRequest } from '../types/SubscribeCalendarRequest';
import type { TeamSnapSubscribeCalendarRequest } from '../types/TeamSnapSubscribeCalendarRequest';

function localLieUpdateToCalendarSubscriptionsRequest(
    providerType: CalendarProviderType.TeamSnap,
    providerId: string,
    subscribeRequests: TeamSnapSubscribeCalendarRequest[],
    unsubscribeCalendarIds: string[]
): {
    providerType: CalendarProviderType.TeamSnap;
    providerId: string;
    subscribeRequests: TeamSnapSubscribeCalendarRequest[];
    unsubscribeCalendarIds: string[];
};
function localLieUpdateToCalendarSubscriptionsRequest(
    providerType: Exclude<CalendarProviderType, CalendarProviderType.TeamSnap>,
    providerId: string,
    subscribeRequests: SubscribeCalendarRequest[],
    unsubscribeCalendarIds: string[]
): {
    providerType: Exclude<CalendarProviderType, CalendarProviderType.TeamSnap>;
    providerId: string;
    subscribeRequests: SubscribeCalendarRequest[];
    unsubscribeCalendarIds: string[];
};
function localLieUpdateToCalendarSubscriptionsRequest(
    providerType: CalendarProviderType,
    providerId: string,
    subscribeRequests: SubscribeCalendarRequest[],
    unsubscribeCalendarIds: string[]
): {
    providerType: CalendarProviderType;
    providerId: string;
    subscribeRequests: SubscribeCalendarRequest[];
    unsubscribeCalendarIds: string[];
} {
    return { providerType, providerId, subscribeRequests, unsubscribeCalendarIds };
}

export const localLieUpdateToCalendarSubscriptions = action(
    'LOCAL_LIE_UPDATE_TO_CALENDAR_SUBSCRIPTIONS_REQUEST',
    localLieUpdateToCalendarSubscriptionsRequest
);
